import axios from "axios";
import Config from "../utils/Config";

class AccountReceivableService{
    config = {
        headers: {
          Authorization: "",
          GroupId: "",
          CompanyId: "",
        },
      };
    
      setAccessToken(accessToken, groupId, companyId) {
        this.config.headers.Authorization = accessToken;
        this.config.headers.GroupId = groupId;
        this.config.headers.CompanyId = companyId;
      }

    //get account receivable search data
    // async GetAccountReceivableSearchData (accessToken, groupId, companyId){
    //   this.setAccessToken(accessToken, groupId, companyId);
    //   const data = await axios.get(
    //   Config.BACKEND_URL + `/api/docMogu/invoicesAndExtractedData?companyId=${companyId}&documentType=Accounts receivable`, //Payble has no data thats (change this to payable later)?
    //   this.config);
    //   return data.data;
    // }

    async GetAccountReceivableSearchData(
      accessToken,
      groupId,
      companyId,
      onRow,
      onMeta,
      onDone,
      fromDate = null,
      toDate = null
    ) {
      let url = `${Config.BACKEND_URL}/api/docMogu/invoicesAndExtractedData?companyId=${companyId}&documentType=Accounts receivable`;
      if (fromDate && toDate) {
        url += `&fromDate=${encodeURIComponent(fromDate)}&toDate=${encodeURIComponent(toDate)}`;
      }
      
      const response = await fetch(
        url,
        {
          headers: {
            Authorization: accessToken,
            GroupId: groupId,
            CompanyId: companyId,
          },
        }
      );
    
      if (!response.body) {
        throw new Error("Streaming not supported");
      }
    
      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let buffer = "";
    
      while (true) {
        const { value, done } = await reader.read();
        if (done) break;
    
        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split("\n");
        buffer = lines.pop(); // keep incomplete line
    
        for (const line of lines) {
          if (!line.trim()) continue;
    
          const message = JSON.parse(line);
    
          if (message.type === "meta" && onMeta) {
            onMeta(message.total);
          }
    
          if (message.type === "row" && onRow) {
            onRow(message.data);
          }
    
          if (message.type === "done" && onDone) {
            onDone();
          }
        }
      }
    }

    async GetAccountReceivableSearchDataNormal(accessToken, groupId, companyId) {
      this.setAccessToken(accessToken, groupId, companyId);
      const data = await axios.get(
        `${Config.BACKEND_URL}/api/docMogu/invoicesAndExtractedDataNormal?companyId=${companyId}&documentType=Accounts receivable`,
        this.config
      );
      return data.data;
    }

    //Submit invoices
    async InvoiceSubmition(accessToken,groupId, companyId,payload) {
      console.log("API Side payload",JSON.stringify(payload))
      this.setAccessToken(accessToken, groupId,companyId);
      const data = await axios.post(
        Config.BACKEND_URL + "/api/docMogu/invoiceSubmission", 
        payload,
        this.config
      );
      return data.data;
    } 
}

export default new AccountReceivableService();